var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.311.257a4.5 4.5 0 00-5.289 1.83l-7.755 12.187a16.544 16.544 0 00-11.123 2l-.005.004a4.5 4.5 0 00-.9 7.068l7.149 7.148L.439 45.444a1.5 1.5 0 102.122 2.121l14.948-14.948 7.153 7.153a4.499 4.499 0 007.068-.9l.003-.006a16.544 16.544 0 002-11.123l12.186-7.755a4.5 4.5 0 00.768-6.978L35 1.32A4.5 4.5 0 0033.31.257zm-1.656 2.755a1.5 1.5 0 011.224.43l11.686 11.686a1.5 1.5 0 01-.256 2.326l-13.058 8.31a1.5 1.5 0 00-.654 1.616c.816 3.388.294 6.96-1.456 9.973a1.502 1.502 0 01-2.355.297L10.358 21.223l-.001-.002a1.501 1.501 0 01.298-2.354 13.544 13.544 0 019.972-1.457 1.5 1.5 0 001.616-.653l8.31-13.06a1.5 1.5 0 011.102-.685z"}));
}

Pin.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Pin;

Pin.default = Pin;
